import React from 'react';
import { SeasonCard } from './ManagerScreen';
import { SackedInfo } from '../../application/hooks/useGameSimulation';
import { soundService } from '../../services/SoundService';
import { AdPlaceholder } from '../shared/AdPlaceholder';
import { TeamBadge } from '../shared/TeamBadge';
import './SackedScreen.css';
import { GameState } from '../../domain/entities';

interface SackedScreenProps {
    sackedInfo: SackedInfo;
    onContinue: (sackedInfo: SackedInfo) => void;
    gameState: GameState;
}

export const SackedScreen: React.FC<SackedScreenProps> = ({ sackedInfo, onContinue, gameState }) => {

    const getTeamByName = (name: string) => {
        if (name === 'Youth Academy') return undefined;
        for (const league of Object.values(gameState.leagues)) {
            const team = league.teams.find(t => t.name === name);
            if (team) return team;
        }
        return undefined;
    };

    const handleContinue = () => {
        soundService.playAdvance();
        onContinue(sackedInfo);
    };

    return (
        <>
            <AdPlaceholder />
            <div className="main-content sacked-screen">
                <h1>You've Been Sacked!</h1>
            <h2>Fired by {getTeamByName(sackedInfo.oldTeamName)?.badge && <TeamBadge badge={getTeamByName(sackedInfo.oldTeamName)?.badge} color={getTeamByName(sackedInfo.oldTeamName)?.colors.primary} size="sm" />}{sackedInfo.oldTeamName}.</h2>
            <div className="sacked-reason">
                <p><strong>The Board's Statement:</strong></p>
                <p>"{sackedInfo.reason}"</p>
            </div>
            
            <div className="sacked-history">
                <h2>Your Career History</h2>
                <div className="sacked-history-cards">
                    {(() => {
                        const elements: React.ReactNode[] = [];
                        let lastTeamName: string | null = null;
                        const reversedHistory = [...sackedInfo.history].reverse();

                        reversedHistory.forEach((record, index) => {
                            if (record.teamName !== lastTeamName) {
                                elements.push(
                                    <h3 key={`team-${record.teamName}-${index}`} className="team-history-separator">
                                        Record at {getTeamByName(record.teamName)?.badge && <TeamBadge badge={getTeamByName(record.teamName)?.badge} color={getTeamByName(record.teamName)?.colors.primary} size="sm" />}{record.teamName}
                                    </h3>
                                );
                                lastTeamName = record.teamName;
                            }
                            const leagueTeamsCount = gameState.leagues[record.leagueName]?.teams.length || 20;
                            // FIX: Added missing 'config' prop to SeasonCard.
                            elements.push(
                                <SeasonCard 
                                    key={`${record.season}-${record.teamName}`} 
                                    record={record} 
                                    isCurrent={false}
                                    leagueTeamsCount={leagueTeamsCount}
                                    config={gameState.config}
                                />
                            );
                        });
                        return elements;
                    })()}
                </div>
            </div>

            <div className="sacked-new-job">
                <h2>A New Opportunity</h2>
                <p>Your agent has worked quickly to find you a new position. You have been appointed as the new manager of...</p>
                <p className="new-team-name">{getTeamByName(sackedInfo.newTeamName)?.badge && <TeamBadge badge={getTeamByName(sackedInfo.newTeamName)?.badge} color={getTeamByName(sackedInfo.newTeamName)?.colors.primary} size="md" />}{sackedInfo.newTeamName}</p>
                <p>It's a chance to rebuild your reputation in {sackedInfo.newTeamLeague}.</p>
            </div>

                <button className="button primary" onClick={handleContinue}>Take the new job & Continue to Next Season</button>
            </div>
        </>
    );
};